import { PromosStylesSchema } from './Promos.styles';

export const promosStyles: PromosStylesSchema = {
  container: {},
  body: {
    color: 'white',
    mt: '-3',
  },
};
